module.exports = __webpack_public_path__ + "img/Loud.ccdfedd7.jpeg";